import { render, staticRenderFns } from "./CarriersView.vue?vue&type=template&id=3eaf1f08&"
import script from "./CarriersView.vue?vue&type=script&lang=js&"
export * from "./CarriersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports